export class Splash {
    static show() {
        // no-oop
    }

    static hide() {
        // no-op
    }
}
